module.exports = __webpack_public_path__ + "static/media/Screenshot_2.1a62e3c3.png";